import { reactive } from "vue";

const toastState = reactive({
  show: false,
  type: "success",
  message: "",
});

let timeoutId = null;

export function useGlobalToast() {
  function showToast(type, message, duration = 5000) {
    toastState.type = type;
    toastState.message = message;
    toastState.show = true;

    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      toastState.show = false;
    }, duration);
  }

  function hideToast() {
    toastState.show = false;
    if (timeoutId) clearTimeout(timeoutId);
  }

  return { toastState, showToast, hideToast };
}
